import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProcessPage = lazy(() => import('../pages/process/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const DualCitizenshipBenefitsBlog = lazy(() => import('../pages/blog/dual-citizenship-benefits/page'));
const WorkingInEuropeBlog = lazy(() => import('../pages/blog/working-in-europe/page'));
const RetiringInIrelandBlog = lazy(() => import('../pages/blog/retiring-in-ireland/page'));
const EUEducationBenefitsBlog = lazy(() => import('../pages/blog/eu-education-benefits/page'));
const IrishCitizenshipByDescentBlog = lazy(() => import('../pages/blog/irish-citizenship-by-descent/page'));
const IrishPassportTravelBenefitsBlog = lazy(() => import('../pages/blog/irish-passport-travel-benefits/page'));
const DigitalNomadIrishCitizenshipBlog = lazy(() => import('../pages/blog/digital-nomad-irish-citizenship/page'));
const IrishAmericanFamiliesBlog = lazy(() => import('../pages/blog/irish-american-families/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const EligibilityGuideArticle = lazy(() => import('../pages/resources/articles/eligibility-guide/page'));
const DocumentTypesArticle = lazy(() => import('../pages/resources/articles/document-types/page'));
const SuccessStoriesPage = lazy(() => import('../pages/success-stories/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const OrderReviewPage = lazy(() => import('../pages/order-review/page'));
const CustomerPortalPage = lazy(() => import('../pages/customer-portal/page'));
const TrackOrderPage = lazy(() => import('../pages/track-order/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminResetPasswordPage = lazy(() => import('../pages/admin/reset-password/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminOrdersPage = lazy(() => import('../pages/admin/orders/page'));
const AdminOrderDetailPage = lazy(() => import('../pages/admin/orders/[id]/page'));
const AdminCustomersPage = lazy(() => import('../pages/admin/customers/page'));
const AdminAnalyticsPage = lazy(() => import('../pages/admin/analytics/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/process',
    element: <ProcessPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/dual-citizenship-benefits',
    element: <DualCitizenshipBenefitsBlog />,
  },
  {
    path: '/blog/working-in-europe',
    element: <WorkingInEuropeBlog />,
  },
  {
    path: '/blog/retiring-in-ireland',
    element: <RetiringInIrelandBlog />,
  },
  {
    path: '/blog/eu-education-benefits',
    element: <EUEducationBenefitsBlog />,
  },
  {
    path: '/blog/irish-citizenship-by-descent',
    element: <IrishCitizenshipByDescentBlog />,
  },
  {
    path: '/blog/irish-passport-travel-benefits',
    element: <IrishPassportTravelBenefitsBlog />,
  },
  {
    path: '/blog/digital-nomad-irish-citizenship',
    element: <DigitalNomadIrishCitizenshipBlog />,
  },
  {
    path: '/blog/irish-american-families',
    element: <IrishAmericanFamiliesBlog />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/resources/articles/eligibility-guide',
    element: <EligibilityGuideArticle />,
  },
  {
    path: '/resources/articles/document-types',
    element: <DocumentTypesArticle />,
  },
  {
    path: '/success-stories',
    element: <SuccessStoriesPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/order-review',
    element: <OrderReviewPage />,
  },
  {
    path: '/customer-portal',
    element: <CustomerPortalPage />,
  },
  {
    path: '/track-order',
    element: <TrackOrderPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/reset-password',
    element: <AdminResetPasswordPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/orders',
    element: <AdminOrdersPage />,
  },
  {
    path: '/admin/orders/:id',
    element: <AdminOrderDetailPage />,
  },
  {
    path: '/admin/customers',
    element: <AdminCustomersPage />,
  },
  {
    path: '/admin/analytics',
    element: <AdminAnalyticsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
